import { render, staticRenderFns } from "./storeChange.vue?vue&type=template&id=1ec312b4&scoped=true"
import script from "./storeChange.vue?vue&type=script&lang=js"
export * from "./storeChange.vue?vue&type=script&lang=js"
import style0 from "./storeChange.vue?vue&type=style&index=0&id=1ec312b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec312b4",
  null
  
)

export default component.exports